import cx from 'classnames';
import { ReactNode } from 'react';
import Message from '../Message/index.js';

interface ErrorDisplayProps {
  errors?: number;
  message?: string | ReactNode;
  visible: boolean;
  id?: string;
}

export default function ErrorDisplay({
  errors,
  message = errors > 1
    ? `You have ${errors} required fields incomplete.`
    : 'You have 1 incomplete field that is required.',
  visible,
  id,
}: ErrorDisplayProps): JSX.Element {
  return (
    // Adding absolute position help escape this element from parent flex calculations when not visible
    <div aria-live="polite" className={cx(!visible && 'absolute')}>
      {visible && (
        <Message variant="error" id={id}>
          {message}
        </Message>
      )}
    </div>
  );
}
